import { WIX_BLOG } from '@wix/app-definition-ids';

import Wix from './wix-sdk-polyfill';
import { getBIService, MA_BLOG_REFS } from './bi';
import { getBaseUrl } from './getBaseUrl';
import { navigateToSection } from './wix-sdk-utils';

const MY_ACCOUNT_APP_DEF_ID = '14cffd81-5215-0a7f-22f8-074b0e2401fb';

const MY_ACCOUNT_PAGE_ID = 'member_info';

export const openContactPage = (msid, uid, isEditorX) => {
  window.open(`${getBaseUrl(isEditorX)}/my-account/sites/${msid}/contacts/view/${uid}`);
};

export const openCreatePostPage = () => {
  getBIService().maMiscClick(MA_BLOG_REFS.BLOG_BWP_CREATE_POST);
  return Wix?.Utils?.navigateToSection(
    {
      appDefinitionId: WIX_BLOG,
      sectionId: 'post',
      shouldRefreshIframe: false,
    },
    'create-post',
    () => {},
  );
};

export const openMyAccountPage = () => {
  const section = { appDefinitionId: MY_ACCOUNT_APP_DEF_ID, sectionId: MY_ACCOUNT_PAGE_ID };
  return navigateToSection(section, () => {});
};

export const openUrl = (url) => (window.top.location.href = url);

export const getLearnMoreLink = (articleId) => {
  const locale = Wix?.Utils?.getLocale();
  return `https://support.wix.com/articles/id/${articleId}?locale=${locale}`;
};

export const getDashboardUrl = (path, referralInfo) => {
  const metaSiteId = Wix?.Utils?.getInstanceValue('metaSiteId');
  const styleParams = Wix?.Styles?.getStyleParams();
  const isEditorX = styleParams?.booleans?.responsive;
  const referralParam = referralInfo ? `?referralInfo=${encodeURI(referralInfo)}` : '';
  return `${getBaseUrl(isEditorX)}/dashboard/${metaSiteId}/${path}${referralParam}`;
};

export const getContactsLink = () => getDashboardUrl('contacts');
